import React from 'react'

import WebhookLoader from './_load/WebhookLoader'
import ModalHeader from './ModalHeader'
import EditStaysWebhookForm from './EditStaysWebhookForm'
import ControlledModal from '../../../../../components/modals/ControlledModal'
import { PermissionChecker } from '../../../../session'

const EditStaysWebhookModal = props => {
  return (
    <ControlledModal width="42rem" disableClickOutside zIndex={'10000'} {...props}>
      <PermissionChecker any={['createPublicToken', 'editPublicToken']}>
        <ModalHeader />
        <WebhookLoader>
          <EditStaysWebhookForm />
        </WebhookLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditStaysWebhookModal
